module.exports = __webpack_public_path__ + "static/media/browser_notification.eaaca325.svg";